module.exports = __webpack_public_path__ + "static/media/DANGER_START_FAST.a4ec497f.mp3";